import { render, staticRenderFns } from "./ThemeCustomization.vue?vue&type=template&id=df71cb18&scoped=true&"
import script from "./ThemeCustomization.vue?vue&type=script&lang=js&"
export * from "./ThemeCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ThemeCustomization.vue?vue&type=style&index=0&id=df71cb18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df71cb18",
  null
  
)

export default component.exports